import { connect } from 'react-redux'
import contentSelector from './contentSelector'
import {
  remove as removeUnsavedChange
} from 'store/redux/unsavedChanges'
import Content from './Content'

export default connect(
  contentSelector,
  {
    removeUnsavedChange
  },
  null,
  {
    forwardRef: true
  }
)(Content)

